// import dotenv from 'dotenv';
// dotenv.config();

type Environment = 'development' | 'production' | 'training';

interface ApiEndpoints {
  featureFlag: string;
  wbs: string;
  careClub: string;
  paf: string;
  puzzel: string;
}

interface NotificationHubs {
  notificationsHub: string;
  trainingHub: string;
  featureFlagNotificationsHub: string;
}

interface AuthEndpoints {
  authClientId: string;
  authService: string;
  puzzelAuth: string;
}

interface AppConfig {
  debug: boolean;
  environment: Environment;
  api: ApiEndpoints;
  notifications: NotificationHubs;
  auth: AuthEndpoints;
}

// Load configuration from environment variables
const config: AppConfig = {
  debug: import.meta.env.PUBLIC_APP_ENVIRONMENT !== 'production',
  environment: import.meta.env.PUBLIC_APP_ENVIRONMENT as Environment,
  api: {
    featureFlag: import.meta.env.PUBLIC_FEATURE_FLAG_API_URL,
    wbs: import.meta.env.PUBLIC_WBS_API_URL,
    careClub: import.meta.env.PUBLIC_CARE_CLUB_API_URL,
    paf: import.meta.env.PUBLIC_PAF_API_URL,
    puzzel: import.meta.env.PUBLIC_PUZZEL_API_URL,
  },
  notifications: {
    notificationsHub: import.meta.env.PUBLIC_WBS_NOTIFICATIONS_HUB_URL,
    trainingHub: import.meta.env?.PUBLIC_TRAINING_NOTIFICATIONS_HUB_URL || '',
    featureFlagNotificationsHub: import.meta.env.PUBLIC_FEATURE_FLAG_NOTIFICATIONS_HUB_URL,
  },
  auth: {
    authClientId: import.meta.env.PUBLIC_AUTH_CLIENT_ID,
    authService: import.meta.env.PUBLIC_AUTH_SERVICE_URL,
    puzzelAuth: import.meta.env.PUBLIC_PUZZEL_AUTH_URL,
  },
};

export default config;
